export const styles = {
  drawer: {
    width: '100%',
    maxWidth: 248,
    paddingTop: '30px',
    marginTop: '64px',
    boxSizing: 'border-box',
    boxShadow: '2px 0px 16px 0px #0000001A',
  },
  listHeader: {
    paddingLeft: '15px',
    textAlign: 'left',
    color: 'text.secondary',
  },
  listItem: {
    height: 48,
    paddingLeft: '30px',
    borderRadius: '0 10px 10px 0',
  },
};
